module.exports = __webpack_public_path__ + "static/media/ei-logo.b1fc2d24.png";